import React, {useEffect, useState} from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {Checkbox} from '@mui/material';
import Dropdown from 'react-dropdown';
import axios from 'axios';
import { Button, Card, Col, Row } from 'react-bootstrap';

export const CatServInactivos = (props) => {
	const {
		Usuario,
		Categorias,
		ServiciosInactivo,
		setServicio,
		setActivar,
		setModalActivarDesactivar,
		sedes,
		sedeId,
		setSedeId,
		serviciosSedes,
		setServiciosSedes,
		seleccionarSede,
		setShowModalEliminarServicio,
		setShowModalModificarServicio,
		estado,
		setEstado,
	} = props;

	useEffect(() => {
		setEstado('inactivo');
	}, []);

	useEffect(() => {
		setActivar(true);
		seleccionarSede(sedeId, estado)
	},[estado]);

	const activarServico = (ServiciosInactivo, sede) => {
		setActivar(true);
		setServicio(ServiciosInactivo);
		setModalActivarDesactivar(true);
		sedeId.push(sede);
		setActivar(false);
	};

	const eliminarServico = (ServiciosActivo, sede) => {
		setServicio(ServiciosActivo);
		setShowModalEliminarServicio(true);
		sedeId.push(sede);
	};
	
	const modificarServicio = (ServiciosActivo, sede) => {
		console.log('ServiciosActivo', ServiciosActivo)
		setServicio(ServiciosActivo);
		getDatosServicio(ServiciosActivo)
		setShowModalModificarServicio(true);
		sedeId.push(sede);
	}

	const getDatosServicio = async (servicio) => {
		let listSedes = []
		await axios({
			method: 'GET',
			url: window.ipdirection + 'Servicio_Sedes?servicio='+servicio.id,
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			}
		}).then((response)=>{
			response.data.map((servicio_sede)=>(
				listSedes.push(servicio_sede.sede_id)
			))

			axios({
				method: 'GET',
				url: window.ipdirection + 'periodoServicioCliente?servicio_empresa='+servicio.id,
				headers: {
					Authorization: 'Bearer ' + Usuario.access,
				}
			}).then((response)=>{
				const diasSemana = ['lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado', 'domingo'];

				// Mapea los datos que vienen del backend agrupados por día
				const mapaDias = {};

				response.data.forEach(periodo => {
					if (!mapaDias[periodo.nombre]) {
						mapaDias[periodo.nombre] = {
							nombre: periodo.nombre,
							estado: periodo.estado,
							periodos: [],
						};
					}

					mapaDias[periodo.nombre].periodos.push({
						id: periodo.id,
						hora_inicio: periodo.hora_inicio,
						hora_fin: periodo.hora_fin,
						solapamiento: false,
					});
				});

				// Ahora genera el horario completo con todos los días
				const horarioCompleto = diasSemana.map((dia) => {
					if (mapaDias[dia]) {
						return mapaDias[dia];
					} else {
						// Si el día no vino de la DB, lo agregamos con estado: false
						return {
							nombre: dia,
							estado: false,
							periodos: [
								{
									id: 1,
									hora_inicio: '',
									hora_fin: '',
									solapamiento: false,
								},
							],
						};
					}
				});

				setServicio({ ...servicio, horario: horarioCompleto, sedes: listSedes });
			})

		})
	}

	// return (
	// 	<>
	// 		<div className='Body-CatServActivos'>
	// 			<div className='categorias-CatServActivos categoriasActivas-CatServActivos'>
	// 				{sedes === undefined ? (
	// 					console.log(undefined)
	// 				) : (
	// 					<Dropdown
	// 						className='dropDown-añaidrServicio-empresa '
	// 						options={sedes.map((sede) => {
	// 							return sede.nombreSede;
	// 						})}
	// 						onChange={(e) => seleccionarSede(e.value)}
	// 						placeholder={'-- Selecionar --'}
	// 					/>
	// 				)}
	// 			</div>
	// 			<div className='categorias-CatServActivos categoriasActivas-CatServActivos'>
	// 				<div className='title-CatServActivos title-1'>
	// 					<h2>Categorias</h2>
	// 					<div className='separador' />
	// 				</div>
	// 				<div className='lista-categoria-CatServActivos lista-categoriaActivas-CatServActivos'>
	// 					{Categorias.map((categoria) => (
	// 						<div className='categoria-CatServActivos categoriaActivas-CatServActivos'>
	// 							<div className='title-CatServActivos title-3'>
	// 								{categoria.categoria_id.nombre}
	// 							</div>
	// 							<div className=''>
	// 								{categoria.categoria_id.superCategoria === 1 &&
	// 									'Servicio Sanitario'}
	// 								{categoria.categoria_id.superCategoria === 2 &&
	// 									'Servicio Socio Sanitario'}
	// 								{categoria.categoria_id.superCategoria === 3 && 'Otros'}
	// 							</div>
	// 						</div>
	// 					))}
	// 				</div>
	// 			</div>
	// 			<div className='servicios-CatServActivos serviciosActivas-CatServActivos'>
	// 				<div className='title-CatServActivos title-1'>
	// 					<h2>Servicios Inactivos</h2>
	// 					<div className='separador' />
	// 				</div>
	// 				{serviciosSedes !== ''
	// 					? Categorias.map((categoria) => (
	// 							<div className='servicio-CatServActivos servicioActivo-CatServActivos'>
	// 								<div className='title-CatServActivos title-2 title-servicios-CatServActivos'>
	// 									<h3>Servicios de {categoria.categoria_id.nombre}</h3>
	// 								</div>
	// 								<div className='separador' />
	// 								<div className='lista-servicio-CatServActivos '>
	// 									{ServiciosInactivo &&
	// 									ServiciosInactivo.map(
	// 										(ServiciosInactivo) =>
	// 											ServiciosInactivo.servicio_id.categoria_id.id ===
	// 												categoria.categoria_id.id &&
	// 											serviciosSedes.map(
	// 												(serviciosSede) =>
	// 													ServiciosInactivo.id ===
	// 														serviciosSede.servicio_id && (
	// 														<div className='card-servicio-CatServActivos'>
	// 															<div
	// 																className='title-CatServActivos title-3 title-servicio-CatServActivos'
	// 																onClick={() =>
	// 																	activarServico(
	// 																		ServiciosInactivo.id,
	// 																		serviciosSede.sede_id
	// 																	)
	// 																}
	// 															>
	// 																<div className='centrador'>
	// 																	{ServiciosInactivo
	// 																		.servicio_id.nombre +
	// 																		' - ' +
	// 																		categoria.categoria_id
	// 																			.nombre}
	// 																</div>
	// 																<button className='btn login-boton'>
	// 																	<div>Activar</div>
	// 																</button>
	// 															</div>
	// 															<div className='separador' />
	// 															<div className='descripcion-servicio'>
	// 																{ServiciosInactivo.descripcion}
	// 															</div>
	// 															<div className='descripcion-servicio'>
	// 																<b>Duracion: </b>
	// 																{
	// 																	ServiciosInactivo.horasMin
	// 																}{' '}
	// 																minutos
	// 															</div>
	// 															<div className='descripcion-servicio'>
	// 																<b>Precio: </b>
	// 																{ServiciosInactivo.precioMin} €
	// 															</div>
	// 															<div className='tipes-servicios-descripcion-servicio'>
	// 																{ServiciosInactivo.domicilio && (
	// 																	<div className='centradorLeft'>
	// 																		<div className='domicilio-servicioOfrecido-perfilAgencia-nuevo'>
	// 																			Domicilio
	// 																		</div>
	// 																	</div>
	// 																)}
	// 																{ServiciosInactivo.shareCare && (
	// 																	<div className='centradorLeft'>
	// 																		<div className='shareCare-servicioOfrecido-perfilAgencia-nuevo'>
	// 																			ShareCare
	// 																		</div>
	// 																	</div>
	// 																)}
	// 															</div>
	// 														</div>
	// 													)
	// 											)
	// 									)}
	// 								</div>
	// 							</div>
	// 					))
	// 					: null}
	// 			</div>
	// 		</div>
	// 	</>
	// );
	const categoriasUnicas = Categorias.filter(
		(categoria, index, self) =>
			index ===
			self.findIndex((c) => c.categoria_id.id === categoria.categoria_id.id)
	);
	
	return (
		<div className='Body-CatServActivos'>
			{/* Dropdown de selección de sede */}
			<div className='categorias-CatServActivos categoriasActivas-CatServActivos'>
				{sedes && (
					<Dropdown
						options={sedes.map((sede) => sede.nombreSede)}
						onChange={(e) => {seleccionarSede(e.value, estado); setSedeId(e.value)}}
						placeholder={'-- Seleccionar --'}
						value={sedeId}
					/>
				)}
			</div>

			{/* Lista de Categorías */}
			<div className='categorias-CatServActivos categoriasActivas-CatServActivos'>
				<div className='title-CatServActivos title-1'>
					<h2>Categorías</h2>
					<div className='separador' />
				</div>
				<div className='lista-categoria-CatServActivos lista-categoriaActivas-CatServActivos'>
					{categoriasUnicas.map((categoria) => (
						<div key={categoria.categoria_id.id} className='categoria-CatServActivos categoriaActivas-CatServActivos'>
							<div className='title-CatServActivos title-3'>
								{categoria.categoria_id.nombre}
							</div>
							<div className=''>
								{categoria.categoria_id.superCategoria === 1 && 'Servicio Sanitario'}
								{categoria.categoria_id.superCategoria === 2 && 'Servicio Socio Sanitario'}
								{categoria.categoria_id.superCategoria === 3 && 'Otros'}
							</div>
						</div>
					))}
				</div>
			</div>

			{/* Lista de Servicios Activos */}
			<div className='servicios-CatServActivos serviciosActivas-CatServActivos'>
				<div className='title-CatServActivos title-1'>
					<h2>Servicios</h2>
					<div className='separador' />
				</div>

				{serviciosSedes !== '' &&
					categoriasUnicas.map((categoria) => {
						const serviciosFiltrados = ServiciosInactivo.filter(
							(servicio) =>
								servicio.servicio_id.categoria_id.id === categoria.categoria_id.id &&
								serviciosSedes.some((sedeServ) => sedeServ.servicio_id === servicio.id)
						);

						if (serviciosFiltrados.length === 0) return null;

						return (
							<div key={categoria.categoria_id.id} className="mb-5">
								<h5 className="mb-3">Servicios de {categoria.categoria_id.nombre}</h5>
								{/* <div className="row">
									{serviciosFiltrados.map((servicio) => {
										const serviciosSede = serviciosSedes.find(
											(sedeServ) => sedeServ.servicio_id === servicio.id
										);

										return (
											<div key={servicio.id} className="w-full mb-4">
												<div className="card shadow-sm h-100">
													<div className="card-body d-flex flex-column justify-content-between">
														<div>
															<div className='row'>
																<h6
																	className="card-title fw-bold col-6"
																	style={{ cursor: 'pointer' }}
																	onClick={() =>
																		activarServico(servicio.id, serviciosSede?.sede_id)
																	}
																>
																	{servicio.servicio_id.nombre} - {categoria.categoria_id.nombre}
																</h6>
																<div className="col-6 text-end">
																	<button className='btn login-boton'
																		onClick={() =>
																			activarServico(servicio.id, serviciosSede?.sede_id)
																		}
																	>
																		Activar
																	</button>
																</div>
															</div>
															<p className="card-text small text-muted">
																{servicio.descripcion}
															</p>
														</div>

														<div className="mt-3">
															<ul className="list-unstyled small mb-2">
																<li><strong>Duración:</strong> {servicio.horasMin} minutos</li>
																<li><strong>Precio:</strong> {servicio.precioMin} €</li>
																{servicio.domicilio && <li>Domicilio</li>}
																{servicio.shareCare && <li>ShareCare</li>}
															</ul>
														</div>
													</div>
												</div>
											</div>
										);
									})}
								</div> */}
								<Row>
									{serviciosFiltrados.map((servicio) => {
										const serviciosSede = serviciosSedes.find(
										(sedeServ) => sedeServ.servicio_id === servicio.id
										);

										return (
										<Col md={12} key={servicio.id} className='my-1'>
											<Card className="p-3 shadow-sm h-100">
											<Row className="g-3 align-items-center">

												{/* Columna izquierda: nombre y categoría */}
												<Col md={6}>
												<div>
													<h6
													className="fw-bold mb-1"
													style={{ cursor: 'pointer' }}
													onClick={() => {
														activarServico(servicio.id, serviciosSede?.sede_id);
													}}
													>
													{servicio.servicio_id.nombre} - {categoria.categoria_id.nombre}
													</h6>
													<div className="text-muted small mb-2">
													{servicio.descripcion}
													</div>
													<ul className="list-unstyled small mb-0">
													<li><strong>Duración:</strong> {servicio.horasMin} minutos</li>
													<li><strong>Precio:</strong> {servicio.precioMin} €</li>
													{servicio.domicilio && <li>Domicilio</li>}
													{servicio.shareCare && <li>ShareCare</li>}
													</ul>
												</div>
												</Col>

												{/* Columna derecha: botones */}
												<Col md={6} className="d-flex flex-column justify-content-center align-items-end gap-2">
													<Button
														variant="success"
														className='btn login-boton'
														size='sm'
														onClick={() => activarServico(servicio.id, serviciosSede?.sede_id)}
													>
														Activar
													</Button>
													<div className='w-fit flex gap-1'>
														<Button
															title='Editar'
															className='outline-boton'
															size='sm'
															onClick={()=>modificarServicio(servicio, serviciosSede?.sede_id)}
														>
															<i class="bi bi-pencil-square"></i>
														</Button>
														<Button
															title='Eliminar'
															variant="outline-danger"
															size='sm'
															onClick={()=>eliminarServico(servicio.id, serviciosSede?.sede_id)}
														>
															<i class="bi bi-trash"></i>
														</Button>
													</div>
													
												</Col>

											</Row>
											</Card>
										</Col>
										);
									})}
									</Row>
							</div>
						);

					})}
			</div>
		</div>
	);
};
